{
  "pt": {
    "task": {
      "actions": {
        "create": "Tarefa",
        "update": "Editar tarefa"
      },
      "attributes": {
        "assignments_count": "Atribuições",
        "category": "Categoria",
        "created_at": "Criado em",
        "description": "Descrição",
        "title": "Título",
        "units": "Unidades"
      },
      "categories": {
        "confirmation": "Confirmação",
        "upload": "Carregamento"
      },
      "labels": {
        "no_tasks": "Ainda não há tarefas para este projeto.",
        "required": "Este campo é obrigatório",
        "units_required": "Selecione pelo menos uma unidade"
      },
      "toasts": {
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "update": "Tarefa atualizada"
      }
    }
  }
}
